import calenderChecked from '../../../images/calenderChecked.svg';
import { FormatDate } from '../../../utils/formatDate';
import {
    formatMachineElectricPower,
    formatMachineIntensity,
    MACHINE_INTENSITY_LABEL,
} from '../../../utils/machineElectricalDisplay';
import {
    getMachineDimensionsLabel,
    hasDisplayValue,
    hasRichTextContent,
} from '../../../utils/publicMachineDisplayUtils';
import { Box, Typography, Grid } from '@mui/material';
import calender from '../../../images/calender.svg';
import measure from '../../../images/measure.svg';
import { useTranslation } from 'react-i18next';
import Iconify from '../../Iconify';
import MachineEvalUtilisationSection from '../MachineEvalUtilisationSection';
import RichTextDisplay from '../../richText/RichTextDisplay';
import '../../../css/machines/modeEtConsigne.css';

const PublicMachineModeEtConsigne = ({ machine }) => {

    const { t } = useTranslation();

    const showModeEmploi = hasRichTextContent(machine?.Instructions_for_use);
    const showMesures = hasRichTextContent(machine?.Safety_instructions);

    const characteristicItems = [
        { icon: 'gis:regular-shape-o', title: t('Marque :'), value: machine?.marque?.name },
        { image: measure, title: t('Dimensions :'), value: getMachineDimensionsLabel(machine) },
        { icon: 'ic:baseline-qr-code', title: t('Codification interne :'), value: machine?.internal_codification },
        { icon: 'material-symbols-light:electric-bolt-rounded', title: t('Puissance électrique :'), value: formatMachineElectricPower(machine?.electric_power) },
        { image: calender, title: t('Date de fabrication :'), value: FormatDate(machine?.manufacture_date) },
        { image: calenderChecked, title: t('Date de mise en service :'), value: FormatDate(machine?.commissioning_date) },
        { icon: 'mdi:users-outline', title: t('Destinée à :'), value: machine?.Dedicated_to },
        { icon: 'mdi:tag-outline', title: t('Modèle :'), value: machine?.model },
        { icon: 'ic:outline-folder-open', title: t('Type de machine :'), value: machine?.type },
        { icon: 'mdi:hashtag', title: t('Numéro de série :'), value: machine?.serial_number },
        { icon: 'material-symbols:power-plug-outline', title: `${t(MACHINE_INTENSITY_LABEL)} :`, value: formatMachineIntensity(machine?.intensity) },
        { image: calender, title: t('Date d’achat :'), value: FormatDate(machine?.purchase_date) },
    ].filter((item) => hasDisplayValue(item.value));

    const showCaracteristiques = characteristicItems.length > 0;
    const showEval = hasDisplayValue(machine?.eval_utilisation_url?.trim());

    if (!showModeEmploi && !showMesures && !showEval && !showCaracteristiques) {
        return null;
    }

    const CharacteristicBox = ({ icon, image, title, value }) => (
        <Box className='modeEtConsigne_caracteristique_text_box'>
            {icon ? (
                <Iconify className='modeEtConsigne_caracteristique_icons' icon={icon} />
            ) : (
                <img src={image} alt="icon" className='modeEtConsigne_caracteristique_icons' loading='lazy' decoding='async' />
            )}
            <Box className='modeEtConseigne_icon_title_response_box'>
                <Typography className='modeEtConsigne_caracteristique_text'>{title}</Typography>
                <Typography className='modeEtConseigne_text_response'>{value}</Typography>
            </Box>
        </Box>
    );

    return (
        <Box className='modeEtConsigne_main_box'>
            {showModeEmploi && (
                <Box className='modeEtConsigne_box'>
                    <Box className='modeEtConsigne_edit_box'>
                        <Typography className='modeEtConsigne_title'>{t('Mode d’emploi')}</Typography>
                    </Box>
                    <RichTextDisplay html={machine.Instructions_for_use} className='publicRichBody' />
                </Box>
            )}
            {showMesures && (
                <Box className='modeEtConsigne_box'>
                    <Box className='modeEtConsigne_edit_box'>
                        <Typography className='modeEtConsigne_title'>{t('Mesures de prévention')}</Typography>
                    </Box>
                    <RichTextDisplay html={machine.Safety_instructions} className='publicRichBody' />
                </Box>
            )}
            {showEval && (
                <MachineEvalUtilisationSection evalUtilisationUrl={machine.eval_utilisation_url} />
            )}
            {showCaracteristiques && (
                <Box className='modeEtConsigne_caracteristique_box'>
                    <Box className='modeEtConsigne_edit_box'>
                        <Typography className='modeEtConsigne_title'>{t('Caractéristiques')}</Typography>
                    </Box>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            {characteristicItems.map((item) => (
                                <CharacteristicBox
                                    key={item.title}
                                    icon={item.icon}
                                    image={item.image}
                                    title={item.title}
                                    value={item.value}
                                />
                            ))}
                        </Grid>
                    </Grid>
                </Box>
            )}
        </Box>
    );
};

export default PublicMachineModeEtConsigne;
